import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      name: "/adminLogin",
      meta: {
        isLogin: false
      },
      component: resolve => require(["../views/admin/AdminLogin.vue"], resolve)
    },
    {
      path: "/admin",
      name: "/adminLogin",
      meta: {
        isLogin: false
      },
      component: resolve => require(["../views/admin/AdminLogin.vue"], resolve)
    },
    {
      path: "/admin/admin",
      name: "/admin",
      component: resolve => require(["../views/admin/Admin.vue"], resolve),
      children: [
        {
          path: "/admin/admin",
          name: "/admin/admin",
          meta: {
            isLogin: false
          },
          component: resolve => require(["../views/admin/Home.vue"], resolve)
        },
        {
          //部门管理
          path: "/admin/department",
          name: "/admindepartment ",
          component: resolve =>
            require(["../views/admin/Department.vue"], resolve)
        },
        {
          //员工管理
          path: "/admin/staff",
          name: "/adminstaff",
          component: resolve => require(["../views/admin/Staff.vue"], resolve)
        },
        {
          //访客管理
          path: "/admin/visitor",
          name: "/adminvisitor",
          component: resolve => require(["../views/admin/Visitor.vue"], resolve)
        },
        {
          //来访事由管理 —— 访客预约
          path: "/admin/reasons",
          name: "/adminreasons",
          component: resolve => require(["../views/admin/Reasons.vue"], resolve)
        },
        {
          //来访事由管理 —— 员工邀请
          path: "/admin/reasonsInvite",
          name: "/adminreasonsInvite",
          component: resolve =>
            require(["../views/admin/ReasonsInvite.vue"], resolve)
        },
        {
          //访客拜访地点
          path: "/admin/area",
          name: "/adminarea",
          component: resolve => require(["../views/admin/Area.vue"], resolve)
        },
        {
          //员工拜访地点
          path: "/admin/areaInvite",
          name: "/adminareaInvite",
          component: resolve =>
            require(["../views/admin/AreaInvite.vue"], resolve)
        },
        {
          //访客拜访区域
          path: "/admin/area2",
          name: "/adminarea2",
          component: resolve => require(["../views/admin/Area2.vue"], resolve)
        },
        {
          //员工拜访区域
          path: "/admin/area2Invite",
          name: "/adminarea2Invite",
          component: resolve =>
            require(["../views/admin/Area2Invite.vue"], resolve)
        },
        {
          //来访类型
          path: "/admin/type",
          name: "/admintype",
          component: resolve =>
            require(["../views/admin/VisitorType.vue"], resolve)
        },
        {
          //来访类型
          path: "/admin/typeInvite",
          name: "/VisitorTypeInvite",
          component: resolve =>
            require(["../views/admin/VisitorTypeInvite.vue"], resolve)
        },
        {
          //物品类型
          path: "/admin/itemType",
          name: "/itemType",
          component: resolve =>
            require(["../views/admin/ItemType.vue"], resolve)
        },
        {
          //放行类型
          path: "/admin/releaseReason",
          name: "/releaseReason",
          component: resolve =>
            require(["../views/admin/ReleaseReason.vue"], resolve)
        },
        {
          //预约记录
          path: "/admin/reserve",
          name: "/adminreserve",
          component: resolve =>
            require(["../views/admin/RecordReserve.vue"], resolve)
        },
        {
          //货车预约记录
          path: "/admin/reserveCar",
          name: "/adminreserveCar",
          component: resolve =>
            require(["../views/admin/RecordReserveCar.vue"], resolve)
        },
        {
          //预约记录
          path: "/admin/releaserecord",
          name: "/adminreleaserecord",
          component: resolve =>
            require(["../views/admin/RecordRelease.vue"], resolve)
        },
        {
          //到访记录
          path: "/admin/arrive",
          name: "/adminarrive",
          component: resolve => require(["../views/admin/Arrive.vue"], resolve)
        },
        {
          //门禁管理
          path: "/admin/region",
          name: "/adminregion",
          component: resolve => require(["../views/admin/Region.vue"], resolve)
        },
        {
          //账号管理
          path: "/admin/account",
          name: "/adminaccount",
          component: resolve => require(["../views/admin/Account.vue"], resolve)
        },
        {
          //放行类别
          path: "/admin/ReleaseType",
          name: "/adminReleaseType",
          component: resolve =>
            require(["../views/admin/ReleaseType.vue"], resolve)
        },

        {
          //考试题目
          path: "/admin/timu",
          name: "/adminTimu",
          component: resolve => require(["../views/admin/Timu.vue"], resolve)
        },

        {
          //邀请记录
          path: "/admin/invite",
          name: "/adminInvite",
          component: resolve =>
            require(["../views/admin/RecordInvite.vue"], resolve)
        },
        {
          //访客通行记录
          path: "/admin/visitorPass",
          name: "/visitorPass",
          component: resolve =>
            require(["../views/admin/RecordVisitorPass.vue"], resolve)
        },
        {
          //邀请记录
          path: "/admin/staffPass",
          name: "/staffPass",
          component: resolve =>
            require(["../views/admin/RecordStaffPass.vue"], resolve)
        },
        {
          //设备管理
          path: "/admin/device",
          name: "/device",
          component: resolve => require(["../views/admin/Device.vue"], resolve)
        },
        {
          //审批流程
          path: "/admin/Workflow",
          name: "/Workflow",
          component: resolve =>
            require(["../views/admin/Workflow.vue"], resolve)
        },
        {
          //审批流程
          path: "/admin/WorkflowList",
          name: "/WorkflowList",
          component: resolve =>
            require(["../views/admin/WorkflowList.vue"], resolve)
        },
        {
          //访客预约主图
          path: "/admin/MainPhoto",
          name: "/adminMainPhoto",
          component: resolve =>
            require(["../views/admin/MainPhoto.vue"], resolve)
        },
        {
          //员工邀请主图
          path: "/admin/MainPhotoInvite",
          name: "/adminMainPhotoInvite",
          component: resolve =>
            require(["../views/admin/MainPhotoInvite.vue"], resolve)
        },
        {
          // 现场登记
          path: "/admin/RecordRegister",
          name: "/adminRecordRegister",
          component: resolve =>
            require(["../views/admin/RecordRegister.vue"], resolve)
        },
        {
          // 二维码通行
          path: "/admin/RecordPass",
          name: "/adminRecordPass",
          component: resolve =>
            require(["../views/admin/RecordPass.vue"], resolve)
        },
        {
          // 无效通行数据
          path: "/admin/RecordErrPass",
          name: "/adminRecordErrPass",
          component: resolve =>
            require(["../views/admin/RecordErrPass.vue"], resolve)
        },

        {
          // 公司管理
          path: "/admin/Company",
          name: "/adminCompany",
          component: resolve => require(["../views/admin/Company.vue"], resolve)
        },
        {
          // 应用管理
          path: "/admin/Corp",
          name: "/adminCorp",
          component: resolve => require(["../views/admin/Corp.vue"], resolve)
        },
        {
          // 组织管理
          path: "/admin/Organize",
          name: "/adminOrganize",
          component: resolve => require(["../views/admin/Organize.vue"], resolve)
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js